import { useContext } from "react";
import { UserContext, UserContextType } from "../context/UserContext";

const useUser = () => useContext<UserContextType>(UserContext);

export default useUser;
